<template>
  <basicContainer>
    <div>
      <!-- 员工维度统计-详情 -->
      <avue-crud
        ref="avueCrud"
        :data="tableData"
        :option="option"
        v-model="form"
        :table-loading="TABLE_LOADING"
        :page.sync="TABLE_PAGE"
        @search-change="SEARCH_CHANGE"
        @refresh-change="TABLE_REFRESH"
        @search-reset="SEARCH_RESET"
        @cell-click="CELL_CLICK"
        @selection-change="SELECTION_CHANGE"
        @sort-change="SORT_CHANGE"
        @size-change="SIZE_CHANGE"
        @current-change="CURRENT_CHANGE"
        :before-open="beforeOpen"
        :before-close="beforeClose"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @row-del="rowDel"
      >
        <template slot-scope="{ type, size, row }" slot="menu">
          <el-button
            icon="el-icon-view"
            :size="size"
            :type="type"
            @click="viewDetail(row)"
            >查看</el-button
          >
        </template>
        <template slot="menuLeft">
          <el-button type="primary" size="mini" @click="goback" plain
            >返回</el-button
          >
        </template>
      </avue-crud>
      <viewFormDialog :option="viewFormOption"></viewFormDialog>
    </div>
  </basicContainer>
</template>

<script>
import { dateFormat } from '@/framework/util/date.js'
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'
import { avueOptionsHandle } from '@/businessManagement/utils/jwTools.js'
import showValue from '@/portal/other/dataPortal/JXKH/dailyReport/js/index.js'
import viewFormDialog from '@/portal/other/dataPortal/JXKH/dailyReport/components/viewFormDialog.vue'
export default {
  mixins: [crudPageMinix, showValue],
  components: { viewFormDialog },
  data() {
    return {
      option: avueOptionsHandle({
        stripe: true,
        border: true,
        page: true,
        selection: false,
        tip: false,
        align: 'right',
        menuAlign: 'center',
        searchMenuSpan: 4,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 170,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: true,
        menuWidth: 100,
        emptyBtn: false,
        column: [
          {
            label: '选择时间段',
            prop: 'sjd',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
            clearable: false,
            searchSpan: 8,
            searchRange: true,
            searchLabelWidth: 100,
            hide: true,
            search: true,
            searchValue: this.showValue(['kssj', 'jssj']) || [
              dateFormat(new Date(), 'yyyy-MM-dd'),
              dateFormat(new Date(), 'yyyy-MM-dd')
            ]
          },
          {
            label: '填写日期',
            prop: 'txrq',
            minWidth: 120
          },
          {
            label: '姓名',
            prop: 'xm',
            minWidth: 120
          },
          {
            label: '直属主管',
            prop: 'zszg',
            minWidth: 120
          },
          {
            label: '任务内工时',
            prop: 'zsc',
            minWidth: 120
          },
          {
            label: '任务内时长',
            prop: 'zsc',
            minWidth: 120
          },
          {
            label: '任务完成率',
            prop: 'rwwcl',
            minWidth: 120
          },
          {
            label: '主管评分',
            prop: 'zgpf',
            minWidth: 120
          }
        ]
      }),
      form: {},
      tableData: [],
      viewFormOption: {
        title: '员工日报',
        src: '',
        dialogVisible: false
      }
    }
  },
  methods: {
    loadData(
      TABLE_PAGE = this.TABLE_PAGE,
      QUERY_CONDITIONS = this.QUERY_CONDITIONS,
      TABLE_ORDER = this.TABLE_ORDER,
      done
    ) {
      this.TABLE_LOADING = true // 表格转圈
      if (QUERY_CONDITIONS.sjd) {
        QUERY_CONDITIONS.kssj = QUERY_CONDITIONS.sjd[0]
        QUERY_CONDITIONS.jssj = QUERY_CONDITIONS.sjd[1]
      } else {
        QUERY_CONDITIONS.kssj = dateFormat(new Date(), 'yyyy-MM-dd')
        QUERY_CONDITIONS.jssj = dateFormat(new Date(), 'yyyy-MM-dd')
      }
      this.$http
        .post('/RbReport/queryNewRbReportYgxq', null, {
          params: {
            pageNum: TABLE_PAGE.currentPage,
            pageSize: TABLE_PAGE.pageSize,
            ...QUERY_CONDITIONS,
            zh: this.$route.query.ryid
          }
        })
        .then((response) => {
          this.RELOAD_CRUD(response.data.records)
          this.TABLE_PAGE.total =
            response.data.total || response.data.records.length
          this.SELECT_LIST = []
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
        .finally(() => {
          this.TABLE_LOADING = false // 表格转圈
          typeof done === 'function' && done()
        })
    },
    viewDetail(row) {
      this.viewFormOption.dialogVisible = true
      this.viewFormOption.src = `/#/applyForm?businessKey=${row.id}&processInstanceId=${row.processInstanceId}&taskId&formId=&pageKey=VIEW&showNav=no&isIframe=true&isHiddenBtn=1`
    },
    goback() {
      this.$router.push({
        path: '/rbtj/dailyReportYG',
        query: this.$route.query
      })
    }
  },
  mounted() {
    if (Object.keys(this.$route.query).length) {
      let { QUERY_CONDITIONS } = this.$route.query
      this.QUERY_CONDITIONS = JSON.parse(QUERY_CONDITIONS)
    }
    this.loadData()
  }
}
</script>

<style>
</style>
